module.exports = __webpack_public_path__ + "static/media/ag.f1c7ec53.svg";